'use strict';
var CartSummary = require('./cart-summary');
var Backdrop = require('./backdrop');

var $menuContent = document.querySelector('.main-menu');
var searchWrapper = document.querySelector('.header .header-search-wrapper');
var deskMenu = document.querySelector('.header-menu-desk');
var hamburguerMenu = document.querySelector('.is-desktop .hamburguer');

var Menu = {
  mouseoutId: {},
  hamburguer: function hamburguer(event) {
    event.preventDefault();
    var $menuMobile = document.querySelector('.js-menu-mobile');
    $menuContent.classList.add('lazyload');

    if ($menuMobile.classList.contains('is-open')) {
      document.body.classList.remove('overflow-hidden-mobile');
    } else {
      document.body.classList.add('overflow-hidden-mobile');
    }

    $menuMobile.classList.toggle('is-open');
  },

  hamburguerDesk: function hamburguerDesk(event) {
    event.preventDefault();
    deskMenu.classList.toggle('is-close');
    hamburguerMenu.classList.toggle('is-open');
  },

  mouseover: function mouseover() {
    var $this = $(this).hasClass('js-menu-item-with-sub')
      ? $(this)
      : $(this).closest('.js-menu-item-with-sub');

    clearTimeout(Menu.debounce);
    clearTimeout(Menu.mouseoutId[$this.index()]);

    Menu.debounce = setTimeout(function () {
      $this.addClass('is-open');

      if ($this.hasClass('header-bag')) {
        CartSummary.getSummary('withHover', function () {
          if ($this.find('.cart-summary-wrap').length) Backdrop.show();
        });
      }

      if ($this.hasClass('header-account-item') || $this.hasClass('has-submenu')) {
        Backdrop.show();
      }
    }, 300);
  },

  mouseout: function mouseout() {
    var $this = $(this);

    clearTimeout(Menu.debounce);

    Menu.mouseoutId[$this.index()] = setTimeout(function () {
      $this.removeClass('is-open');
      $this.removeClass('menu-position-right');
      if ($this.closest('.js-menu-item-with-sub').hasClass('is-open')) return;
      Backdrop.hide();
    }, 300);
  },

  toggleSearch: function toggleSearch(event) {
    event.preventDefault();
    if (searchWrapper.classList.contains('is-open')) {
      searchWrapper.classList.add('is-close');
      searchWrapper.classList.remove('is-open');
    } else {
      searchWrapper.classList.add('is-open');
      searchWrapper.classList.remove('is-close');
    }
  },

  close: function close() {
    document.body.classList.remove('overflow-hidden-mobile');
    document.querySelector('.js-menu-mobile').classList.remove('is-open');
  },

  calculatePosition: function () {
    var $menuItem = $(this);
    var $subMenu = $('.header-menu-category', $menuItem).get(0);

    if ($subMenu && !$menuItem.hasClass('menu-item-full-width')) {
      var menuBound = $menuContent.offsetWidth;
      var subMenuBound = $subMenu.offsetLeft + $subMenu.offsetWidth;
      if (subMenuBound > menuBound) {
        $menuItem.addClass('menu-position-right');
      }
    }
  }
};

$('.icon.magnifier').on('click tap', Menu.toggleSearch);

$('.js-menu-open.is-mobile, .js-menu-close').on('click tap', Menu.hamburguer);

$('.js-menu-open.is-desktop, .js-menu-close').on('click tap', Menu.hamburguerDesk);

$('.js-menu-item-with-sub').on('mouseenter', Menu.mouseover).on('mouseleave', Menu.mouseout);

$('.menu-item.has-submenu').on('mouseenter', Menu.calculatePosition);

$('.main-menu').on('click tap', '.js-menu-close', Menu.close);

module.exports = Menu;
